module.exports = __webpack_public_path__ + "0b467671cf48362512adcdba320c0740.MP3";